import GetLogo from './getlogo.js';

export default GetLogo;
